import * as mapboxgl from 'mapbox-gl';
import { GeoJSONSource } from 'mapbox-gl';
import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';

// Gradient stops used to color areas by their normalized density (0 = low, 255 = high).
// Ordered low -> high so the legend renders light at the bottom and dark at the top.
const AREA_LEGEND_COLORS: string[] = ['rgb(232, 255, 232)', 'rgb(76, 175, 64)', 'rgb(38, 105, 32)'];

export class AreasLayer
{
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected fillLayer: BaseFeatureLayer;
    


    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;
        this.fillLayer = new BaseFeatureLayer(mapboxInstance, 'middle', 'areas-fill-layer', 'areas-fill-source', 'fill', {},{
            'fill-color': [
                'interpolate',
                ['linear'],
                ['coalesce', ['to-number', ['get', 'density']], 0],  // ← add 'to-number'
                0, 'rgba(232, 255, 232, 1)',
                128, 'rgba(76, 175, 64, 1)',
                255, 'rgba(38, 105, 32, 1)'
            ],
            'fill-opacity': 0.7
        }, true,true);
       
    }

    private getRow(fieldName: any, value: any, colorResult: boolean = false, postFix: string = '') {
        let value2 = value;
        if (colorResult && value > 0) value2 = '<span class="positiveResult">+' + value + postFix + '</span>';
        if (colorResult && value < 0) value2 = '<span class="negativeResult">' + value + postFix + '</span>';



        return '<div class="tbdc-row"><div>' + fieldName + '</div><div style="text-align: right; margin-left: 1em;">' + value2 + '</div><div></div></div>';

    }

    public DataChanged = async () => {
        if (this.mapboxInstance.areas != null) {
            this.mapboxInstance.areas.forEach((area: any) => {
                area.properties['outline-color'] = 'rgba(38, 105, 32, 1)';
                let titleHtml = '<h3>Area ' + area.properties.Code + '</h3><div class="tbdc-grid">';
                for (const key in area.properties) {
                    if (Object.prototype.hasOwnProperty.call(area.properties, key)) {
                        let value = area.properties[key as keyof typeof area.properties];
                        if (value === 'y') {
                            value = this.mapboxInstance.$t("message.yes");
                        } else if (value === 'n') {
                            value = this.mapboxInstance.$t("message.no");
                        }
                        if (key != 'density' && key != 'Code' && key != 'outline-color' && key != '' && key != null) titleHtml += this.getRow(key, value, false, '');
                    }
                }
                area.properties['titleHtml'] = titleHtml + '</div>';
            });
        }


        this.fillLayer.SetFeatures(this.mapboxInstance.areas == null ? [] : this.mapboxInstance.areas);

        this.updateLegend();
    };

    // Show a legend only when the selected area set actually carries density coloring.
    private updateLegend() {
        const areas = this.mapboxInstance.areas;
        const hasDensity = areas != null && areas.some((area: any) => {
            const density = area.properties?.density;
            return density != null && Number.isFinite(Number(density));
        });
        if (!hasDensity) {
            this.mapboxInstance.$emit('areaLegendChanged', null);
            return;
        }
        const areaSet = this.mapboxInstance.model.areaSets.find((set: any) => set.id == this.mapboxInstance.areaSetVisible);
        const title = areaSet == null ? '' : (areaSet.title == null ? areaSet.name : areaSet.title);
        this.mapboxInstance.$emit('areaLegendChanged', { title, colors: AREA_LEGEND_COLORS });
    }
}   
